module.exports = "/lucky-balls/img/jackpot/004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/004.png
// module id = 1104
// module chunks = 0